var _path, _path2, _path3, _rect, _rect2, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoundersSapphire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H104C112.837 0 120 7.16344 120 16V100C120 133.137 93.1371 160 60 160C26.8629 160 0 133.137 0 100V16Z",
    fill: "#B5B5C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19C4 11.268 10.268 5 18 5H102C109.732 5 116 11.268 116 19V100C116 130.928 90.928 156 60 156C29.0721 156 4 130.928 4 100V19Z",
    fill: "url(#paint0_linear_12_2130)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 41C9 34.3726 14.3726 29 21 29H99C105.627 29 111 34.3726 111 41V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V41Z",
    fill: "url(#paint1_linear_12_2130)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 15,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#2B599D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_2130)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_2130",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 26,
    width: 159,
    height: 158
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 26,
    width: 70,
    height: 153,
    transform: "rotate(45 114 26)",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_2130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 41C9 34.3726 14.3726 29 21 29H99C105.627 29 111 34.3726 111 41V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V41Z",
    fill: "black",
    fillOpacity: 0.3
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 65L60 56L71 65V93L60 102L49 93V65Z",
    fill: "#51ABEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 45V56L71 65L83 59.5L60 45Z",
    fill: "#3D70F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 45V56L49 65L37 59.5L60 45Z",
    fill: "#A6D4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 113V102L71 93L83 98.5L60 113Z",
    fill: "#173BBC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60 113V102L49 93L37 98.5L60 113Z",
    fill: "#2351C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59.5L71 65V93L83 98.5V59.5Z",
    fill: "#2351C8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37 59.5L49 65V93L37 98.5V59.5Z",
    fill: "#3D70F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5437 119.899C58.9191 118.378 61.0809 118.378 61.4563 119.899L62.2577 123.145C62.3912 123.686 62.8136 124.109 63.3545 124.242L66.6009 125.044C68.1216 125.419 68.1216 127.581 66.6009 127.956L63.3545 128.758C62.8136 128.891 62.3912 129.314 62.2577 129.854L61.4563 133.101C61.0809 134.622 58.9191 134.622 58.5437 133.101L57.7423 129.854C57.6087 129.314 57.1864 128.891 56.6455 128.758L53.399 127.956C51.8784 127.581 51.8784 125.419 53.399 125.044L56.6455 124.242C57.1864 124.109 57.6087 123.686 57.7423 123.145L58.5437 119.899Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2130",
    x1: 6.24,
    y1: 8.99815,
    x2: 35.479,
    y2: 114.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#A6A5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898838,
    stopColor: "#D9D9DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_2130",
    x1: 60,
    y1: 29,
    x2: 60,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B599D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0939"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_2130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 122,
    fill: "white",
    transform: "translate(9 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundersSapphire);
export default __webpack_public_path__ + "static/media/foundersSapphire.638755ff2469fad649dd2dcfde3db67a.svg";
export { ForwardRef as ReactComponent };